// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__eWPrT","appLoading":"PageLoader_appLoading__22_cv"};